import {
  Arrow,
  Content,
  Portal,
  Provider,
  Root,
  Trigger,
} from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { classNames } from '../Utils/classNames';

export type TooltipProps = {
  children: ReactNode;
  tooltipText: ReactNode;
  side?: Parameters<typeof Content>[0]['side'];
  align?: Parameters<typeof Content>[0]['align'];
  contentClassName?: string;
  textClassName?: string;
  showArrow?: boolean;
};

export function Tooltip({
  children,
  tooltipText,
  side,
  align,
  contentClassName,
  textClassName,
  showArrow,
}: TooltipProps) {
  return (
    <Provider delayDuration={0}>
      <Root>
        <Trigger asChild className="flex">
          {children}
        </Trigger>
        <Portal>
          <Content
            className={classNames(
              'z-10 inline-flex max-w-[250px] items-center rounded-md bg-gray-9 px-4 py-2 text-xs text-gray-1 shadow-2xl-down',
              contentClassName
            )}
            side={side}
            align={align}
            sideOffset={6}
          >
            {showArrow && <Arrow />}
            <span className={twMerge('break-word', textClassName)}>
              {tooltipText}
            </span>
          </Content>
        </Portal>
      </Root>
    </Provider>
  );
}
